import React from 'react'
import { Props } from './types'

export const Cancel: React.FC<Props> = (props) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <rect
        x="7"
        y=".48"
        width="2"
        height="15.04"
        transform="translate(-3.31 8) rotate(-45)"
      />
      <rect
        x=".48"
        y="7"
        width="15.04"
        height="2"
        transform="translate(-3.31 8) rotate(-45)"
      />
    </svg>
  )
}
